import type BaseEnumType from "@/app/services/baseEnumType";
import { EnumProcessOutputTarget } from "@/app/services/generated/enums/enumProcessOutputTarget.generated";
import type { Maybe } from "@/components/utils/typeHelpers";
import { keys } from "@/plugins/i18n";

export class EnumProcessOutputMovementType implements BaseEnumType {
  private static allValues: EnumProcessOutputMovementType[] = [];

  public static stock = new EnumProcessOutputMovementType(
    0,
    "Stock",
    keys.process_output_movement_type_stock.value,
    EnumProcessOutputTarget.stock
  );
  public static processSameBatch = new EnumProcessOutputMovementType(
    1,
    "Process of Same Batch",
    keys.process_output_movement_type_process_same_batch.value,
    EnumProcessOutputTarget.processSameBatch
  );
  public static processOtherBatch = new EnumProcessOutputMovementType(
    2,
    "Process of Other Batch",
    keys.process_output_movement_type_process_other_batch.value,
    EnumProcessOutputTarget.processOtherBatch
  );

  public static scanAndFillTrackedContainers =
    new EnumProcessOutputMovementType(
      3,
      "Scan and Fill Tracked Containers",
      keys.process_output_movement_type_scan_and_fill_tracked_containers.value,
      EnumProcessOutputTarget.stock
    );

  public key: number;
  public value: string;
  public translationKey: string;
  public processOutputTarget: EnumProcessOutputTarget;

  private constructor(
    key: number,
    value: string,
    translationKey: string,
    processOutputTarget: EnumProcessOutputTarget
  ) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    this.processOutputTarget = processOutputTarget;

    EnumProcessOutputMovementType.allValues.push(this);
  }

  public equals(other: Maybe<EnumProcessOutputMovementType>): boolean {
    return this.key === other?.key;
  }

  public isStock() {
    return this.equals(EnumProcessOutputMovementType.stock);
  }
  public isProcessSameBatch() {
    return this.equals(EnumProcessOutputMovementType.processSameBatch);
  }
  public isProcessOtherBatch() {
    return this.equals(EnumProcessOutputMovementType.processOtherBatch);
  }
  public isScanAndFillTrackedContainers() {
    return this.equals(
      EnumProcessOutputMovementType.scanAndFillTrackedContainers
    );
  }

  public static getValues(): EnumProcessOutputMovementType[] {
    return EnumProcessOutputMovementType.allValues;
  }

  public static getByKey(key: number): EnumProcessOutputMovementType {
    const found = EnumProcessOutputMovementType.allValues.find(
      (e) => e.key === key
    );
    if (found === undefined) {
      throw new Error(`EnumProcessOutputMovementType - Key not found: ${key}`);
    }

    return found;
  }
}
